export default "__VITE_ASSET__CJCT0WEP__"